import { Box, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import type { VpnProtocol } from "../../services/adminVpnProfileService";
import { VPN_PROTOCOLS } from "../../services/adminVpnProfileService";
import ciscoLogo from "../../assets/images/vpn/cisco.svg?raw";
import fortinetLogo from "../../assets/images/vpn/fortinet.svg?raw";
import globalProtectLogo from "../../assets/images/vpn/paloaltonetworks.svg?raw";
import ivantiLogo from "../../assets/images/vpn/ivanti.svg?raw";
import juniperLogo from "../../assets/images/vpn/junipernetworks.svg?raw";
import arrayLogo from "../../assets/images/vpn/arraynetworks.svg?raw";
import f5Logo from "../../assets/images/vpn/f5.svg?raw";

const LOGO_BY_PROTOCOL: Record<VpnProtocol, string> = {
  ANYCONNECT: ciscoLogo,
  FORTINET: fortinetLogo,
  GLOBALPROTECT: globalProtectLogo,
  PULSE: ivantiLogo,
  NETWORK_CONNECT: juniperLogo,
  ARRAY: arrayLogo,
  F5: f5Logo,
};

type Props = {
  protocol?: VpnProtocol | string | null;
  size?: number;
  label?: string;
};

/** Inline currentColor SVG mark that follows light/dark theme icon colors. */
export default function VpnProtocolIcon({ protocol, size = 32, label }: Props) {
  const theme = useTheme();
  const key = (protocol || "") as VpnProtocol;
  const svg = LOGO_BY_PROTOCOL[key];
  const title =
    label || VPN_PROTOCOLS.find((p) => p.value === key)?.label || key || "VPN";
  const isDark = theme.palette.mode === "dark";

  if (!svg) {
    return (
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: 1,
          bgcolor: "action.hover",
          border: 1,
          borderColor: "divider",
          flexShrink: 0,
        }}
        aria-hidden
      />
    );
  }

  const icon = (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: 1,
        bgcolor: isDark ? "rgba(255,255,255,0.06)" : "action.hover",
        border: 1,
        borderColor: "divider",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        p: `${Math.max(5, Math.round(size * 0.18))}px`,
        boxSizing: "border-box",
        color: isDark ? "common.white" : "text.primary",
        "& svg": {
          width: "100%",
          height: "100%",
          display: "block",
        },
      }}
      aria-hidden
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );

  return (
    <Tooltip title={title} placement="top" arrow>
      <span style={{ display: "inline-flex", lineHeight: 0 }}>{icon}</span>
    </Tooltip>
  );
}
